export default "__VITE_ASSET__69208ed5__"